var map = {
	"./art-1.png": "a7c2",
	"./art-10.png": "06a5",
	"./art-11.png": "1c11",
	"./art-12.png": "2796",
	"./art-13.png": "4795",
	"./art-14.png": "9dc8",
	"./art-15.png": "a2d9",
	"./art-16.png": "1f3e",
	"./art-17.png": "313a",
	"./art-18.png": "fcc1",
	"./art-19.png": "f19d",
	"./art-2.png": "949f",
	"./art-20.png": "9d3c",
	"./art-21.png": "8aff",
	"./art-22.png": "c04e",
	"./art-23.png": "d957",
	"./art-24.png": "6431",
	"./art-25.png": "300d",
	"./art-26.png": "60f6",
	"./art-27.png": "b690",
	"./art-28.png": "8c99",
	"./art-29.png": "fadc",
	"./art-3.png": "afc3",
	"./art-30.png": "c0e9",
	"./art-31.png": "c3df",
	"./art-32.png": "9d95",
	"./art-33.png": "cc37",
	"./art-34.png": "46af",
	"./art-35.png": "c2b2",
	"./art-36.png": "d975",
	"./art-37.png": "091c",
	"./art-38.png": "ec95",
	"./art-39.png": "85fa",
	"./art-4.png": "5569",
	"./art-40.png": "6720",
	"./art-41.png": "730b",
	"./art-42.png": "a5aa",
	"./art-43.png": "bfe5",
	"./art-44.png": "90db",
	"./art-45.png": "b9dd",
	"./art-46.png": "e93a",
	"./art-47.png": "77ed",
	"./art-48.png": "4171",
	"./art-49.png": "1aaf",
	"./art-5.png": "9124",
	"./art-50.png": "6349",
	"./art-51.png": "12b7",
	"./art-52.png": "f536",
	"./art-53.png": "341e",
	"./art-54.png": "4394",
	"./art-55.png": "c668",
	"./art-56.png": "fe34",
	"./art-57.png": "047e",
	"./art-58.png": "8efc",
	"./art-59.png": "e4e3",
	"./art-6.png": "9147",
	"./art-60.png": "9b1c",
	"./art-61.png": "e8f5",
	"./art-7.png": "6f28",
	"./art-8.png": "c6f7",
	"./art-9.png": "fb35",
	"./art-qr.png": "4d36"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0379";